import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PickUpListService} from './shared/pick-up-list.service';
import {PickUpListComponent} from './pick-up-list/pick-up-list.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SearchFormComponent} from './search-form/search-form.component';
import {ReservationComponent} from './reservation/reservation.component';
import {ReservationDialogComponent} from './reservation-dialog/reservation-dialog.component';
import {
  MatButtonModule, MatCardModule, MatDialogModule,
  MatIconModule, MatListModule, MatProgressSpinnerModule, MatSelectModule, MatSidenavModule, MatSlideToggleModule,
  MatToolbarModule
} from '@angular/material';
import {NavigationModule} from '../navigation/navigation.module';
import {ReservationService} from './shared/reservation.service';
import {MaterialModule} from '../material/material.module';
import {BrowserModule} from '@angular/platform-browser';
import {AnimationsModule} from '../animations.module';
import {RouterModule} from '@angular/router';
import {CuiAlertDialogModule} from '@cicero/webui/lib/core/dialogs/alert-dialog';
import {CuiPipesModule} from '@cicero/webui/lib/core/pipes/pipes.module';
import {CuiNavbarModule} from '@cicero/webui/lib/navigation/navbar';
import {CuiPagetipModule} from '@cicero/webui/lib/core/pagetip';
import {CuiSwipeableModule} from '@cicero/webui/lib/core/swipeable';
import {CuiVirtualScrollModule} from '@cicero/webui/lib/core/virtual-scroll';
import {CuiOfflineIndicatorModule} from '@cicero/webui/lib/core/offline-indicator';
import {CuiSelectAllModule} from '@cicero/webui/lib/core/select-all/select-all.module';
import {SharedModule} from '../shared/shared.module';

@NgModule({
  imports: [
    BrowserModule,
    AnimationsModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatListModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    NavigationModule,
    MaterialModule,
    CuiAlertDialogModule,
    CuiSwipeableModule,
    CuiVirtualScrollModule,
    CuiPipesModule,
    CuiNavbarModule,
    CuiPagetipModule,
    CuiOfflineIndicatorModule,
    CuiSelectAllModule,
    SharedModule
  ],
  providers: [
    PickUpListService,
    ReservationService
  ],
  declarations: [SearchFormComponent, PickUpListComponent, ReservationComponent, ReservationDialogComponent],
  entryComponents: [
    ReservationDialogComponent
  ]
})
export class PickUpListModule {
}



// WEBPACK FOOTER //
// ./src/app/pick-up-list/pick-up-list.module.ts